import React from "react";
import {ChipLabel} from "./index";

const ChangeEventChip = ({event}) => {
    const eventData = {
        "update": {
            class: "event-chip success",
            text: "Update"
        },
        "pm_update": {
            class: "event-chip success",
            text: "PM Update"
        },
        "revive": {
            class: "event-chip success",
            text: "Revive"
        },
        "reviewed": {
            class: "event-chip secondary",
            text: "Reviewed"
        },
        "downloaded": {
            class: "event-chip secondary",
            text: "Downloaded"
        },
        "destroy": {
            class: "event-chip error",
            text: "Destroy"
        },
        "create": {
            class: "event-chip primary",
            text: "Create"
        },
    }

    return (<ChipLabel label={eventData[event]?.text} className={eventData[event]?.class}/>)
}

export default ChangeEventChip;